// test1245
(1245 && 0);
